export default __webpack_public_path__ + "static/media/customer_illustration.9df5201e.svg";